import { camelcaseToTitlecase } from 'helpers/string.helpers';
import { ResponseStatus } from 'services/assist-api/entities/test-instance-response/types';

/**
 * Returns a human readable version of the response status. Note: all response statuses are
 * currently one word, but consistent with other API enums would be camelcase if a multi-word
 * response status is added.
 */
export function friendlyResponseStatus(status: ResponseStatus): string {
  return camelcaseToTitlecase(status);
}

/**
 * Statuses that the response must be in in order to be marked. Draft responses cannot be marked.
 */
export const markableResponseStatuses: ResponseStatus[] = [
  ResponseStatus.Closed,
  ResponseStatus.Finished
];

/**
 * Returns true if the response has a status that implies that it can be marked.
 */
export function isResponseReadyToBeMarked(status: ResponseStatus | undefined): boolean {
  return status ? markableResponseStatuses.includes(status) : false;
}
